var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 32,
    viewBox: "0 0 64 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48097460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 26",
    d: "M18.2031 0.0625H33.2547L24.6637 18.5516H39.5725H39.6985L48.1203 0.0625H63.0788L54.5311 18.5516H39.6985H39.5725L48.3378 36.8549H33.2547L24.6637 18.5516L16.1592 36.8549H0.921875L18.2031 0.0625Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 543486",
    x: 54.5391,
    y: 28.4141,
    width: 8.44069,
    height: 8.44069,
    rx: 2.78773,
    fill: "#474747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7febdb29d5958f465b8ab80b300bd224.svg";
export { ForwardRef as ReactComponent };